import { pushRoute } from '../../../lib/router.js';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import { FormError } from '../../FormError.jsx';
import OrgStructureCurrentCSVDownloadButton from '../../OrgStructureCurrentCSVDownloadButton.jsx';
import CustomRadio from '../../CustomRadio.jsx';
import OrgStructureExampleCSVDownloadButton from '../../OrgStructureExampleCSVDownloadButton.jsx';
import GroupsTree from './GroupsTree.jsx';
import { AttentionIconLarge } from '../../icons/AttentionIconLarge.jsx';

export const uploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  {
    label: 'Add new organization group to an existing structure',
    value: 'add',
  },
  { label: 'Replace existing structure', value: 'replace' },
];

function GroupsForm(props) {
  const {
    handleSubmit,
    formRef,
    submitError,
    submitFailed,
    submitting,
    employeesCount,
    uploadMethod,
    setUploadMethod,
    replaceMethod,
    setReplaceMethod,
    editableId,
    onDownloadCsv,
    onAddNode,
    groupsTree,
    slug,
  } = props;
  const isActionDisabled = editableId !== null;

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <Row className="m-b-48">
        <Col xs={12}>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Edit Organization Structure</h3>
          </div>
        </Col>
        <Col xs={12}>
          <p className="text-muted m-b-24">
            Upload a CSV or add organization groups manually.
          </p>
        </Col>
        <Col xs={12}>
          <CustomRadio
            name="upload_method"
            checkedValue={uploadMethod}
            options={uploadMethodOptions}
            action={setUploadMethod}
          />
        </Col>
      </Row>

      {uploadMethod === 'csv' ? (
        <React.Fragment>
          {groupsTree.length || !!employeesCount ? (
            <Row className="m-b-48">
              <Col xs={12}>
                <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                  <h3>Existing Organization Structure</h3>
                </div>
              </Col>
              <Col xs={12}>
                <div className="m-b-18">
                  <CustomRadio
                    name="replace_method"
                    checkedValue={replaceMethod}
                    options={replaceOptions}
                    action={setReplaceMethod}
                  />
                </div>
              </Col>
              <Col xs={6}>
                <div
                  className="component-sm component-margin-bottom component-hide-border flex px-26"
                  style={{
                    background: '#F7FAFD',
                    paddingLeft: '26px',
                    paddingRight: '26px',
                  }}
                >
                  <div style={{ width: '30px' }}>
                    <AttentionIconLarge />
                  </div>
                  <p className="text-muted m-b-0 m-l-16">
                    Please note that you are updating the organizational
                    structure for both groups and employees. Ensure both are
                    included in the CSV file for proper updates. We recommend
                    downloading the current CSV, editing it, and re-uploading to
                    align with the new structure.
                  </p>
                </div>
              </Col>
              <Col xs={12}>
                <OrgStructureCurrentCSVDownloadButton
                  onDownloadCsv={onDownloadCsv}
                />
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Bulk CSV Upload</h3>
              </div>
            </Col>
            <Col xs={12}>
              <div className="m-b-18">
                <OrgStructureExampleCSVDownloadButton />
              </div>
            </Col>
            <Col xs={12}>
              <Field
                id="groupsFormCsvFile"
                name="csv_file"
                type="file"
                component={FieldGroup}
                accept=".csv"
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : null}

      {uploadMethod === 'manually' ? (
        <React.Fragment>
          <Row className="m-b-24">
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Edit Groups</h3>
              </div>
            </Col>
          </Row>
          <Row className="m-b-18" style={{ overflowX: 'auto' }}>
            <Col xs={12}>
              <GroupsTree {...props} isActionDisabled={isActionDisabled} />
            </Col>
          </Row>
          <Row className="m-b-48">
            <Col xs={12}>
              <button
                type="button"
                className="btn-link"
                disabled={isActionDisabled}
                onClick={() => onAddNode(null)}
              >
                {' '}
                + Add New Group
              </button>
            </Col>
          </Row>
        </React.Fragment>
      ) : null}

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button
                bsStyle="default"
                onClick={() => pushRoute(`/${slug}/organization`)}
              >
                Cancel
              </Button>

              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
}

export default GroupsForm;
